import { render, staticRenderFns } from "./Unilateral-strategy.vue?vue&type=template&id=916c5b6a&"
import script from "./Unilateral-strategy.vue?vue&type=script&lang=js&"
export * from "./Unilateral-strategy.vue?vue&type=script&lang=js&"
import style0 from "./Unilateral-strategy.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports